import React from 'react';
import ProxySetting from '@/base/ProxySetting';
import Model from '@/base/model/Model';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import en from 'antd/lib/locale/en_US';
import { IntlProvider } from 'react-intl';
import './App.css';
import RouterRender from './base/config/RouterRender';
import localEn from './i18n/en.json';
import locaZhCN from './i18n/zh-CN.json';
import { StyleProvider } from '@ant-design/cssinjs';
import UseMobile from './utils/UseMobile';
ProxySetting.init();
Model.init();

const locale: any = {
  'zh-CN': locaZhCN,
  en: localEn,
};

const antdLocal: any = {
  'zh-CN': zhCN,
  en: en,
};

const currentLanguage = Model.language;

function App() {
  const [isMobile] = UseMobile();

  const element = document.getElementById('root');
  if (element) {
    if (isMobile && currentLanguage === 'en') {
      element.style.setProperty('--title2-size', '18px');
    } else {
      element.style.removeProperty('--title2-size');
    }
  }

  return (
    <StyleProvider hashPriority="high">
      <ConfigProvider locale={antdLocal[currentLanguage] || zhCN}>
        <IntlProvider
          locale={currentLanguage}
          messages={locale[currentLanguage] || locaZhCN}
        >
          <RouterRender />
        </IntlProvider>
      </ConfigProvider>
    </StyleProvider>
  );
}

export default App;
